export default {
  event: {},
  host: {},
  savedGuests: [],
  eventGuests: [],
};
